import React, { useState } from 'react';

const QRCodeScannerPopupHOC = (Component:any) => 
function Comp(props:any){
    const [showQRCodeScannerPopup,setShowQRCodeScannerPopup] = useState<boolean>(false);

    const QRCodeScannerToggleHandler = () => {
        setShowQRCodeScannerPopup(!showQRCodeScannerPopup);
    }
	
	return <Component showQRCodeScannerPopup={showQRCodeScannerPopup} QRCodeScannerToggleHandler={QRCodeScannerToggleHandler} {...props}/>;
};

export default QRCodeScannerPopupHOC;   